export default {
  preCheckIn: {
    langName: 'English',
    steps: {
      reserve: 'Reservation',
      guests: 'Guests',
      confirmation: 'Confirmation',
    },
    step1: {
      title: 'Online Pre-Check-in',
      subtitle: 'Enter your reservation number to start the pre-check-in.',
      reserveNumber: 'Reservation Number',
      continue: 'Continue',
      errorEmpty: 'Please enter the reservation number',
      errorNotFound: 'Reservation not found or not confirmed.',
    },
    step2: {
      reservationLabel: 'Reservation',
      checkIn: 'Check-in',
      checkOut: 'Check-out',
      alreadyDoneTitle: 'Pre-check-in already completed!',
      alreadyDoneBody: 'The guest information for this reservation has already been registered. You can update the information below if needed.',
      progress: 'Pre-check-in in progress: {completed} of {total} guests completed.',
      hotelRules: 'Hotel Rules',
      mainGuestChip: 'Main guest — required for invoice',
      additionalAdultChip: 'Additional adult',
      childChip: 'Child',
      addressSection: 'Address',
      contactSection: 'Contact',
      fnrhSection: 'Guest Registration Details',
      back: 'Back',
      previous: '← Previous',
      next: 'Next →',
      confirm: 'Confirm Pre-Check-in',
      saveGuest: 'Save this guest',
      updateGuest: 'Update this guest',
      guestConfirmedTitle: 'Details confirmed',
      requiredError: 'Please fill in all required fields.',
      fieldRequired: '{field} is required',
      fields: {
        typeDoc: 'Document type',
        cpf: 'CPF',
        cpfOptional: 'CPF (optional)',
        docNumber: 'Document number',
        name: 'Full name',
        firstName: 'First name',
        lastName: 'Last name',
        birthDate: 'Date of birth',
        gender: 'Gender',
        nationality: 'Nationality',
        maritalStatus: 'Marital status',
        profession: 'Profession',
        originCity: 'City of origin',
        issuingBody: 'Issuing authority',
        zipcode: 'ZIP code',
        zipcodePostal: 'ZIP / Postal Code',
        address: 'Address',
        number: 'Number',
        complement: 'Complement',
        neighborhood: 'Neighborhood',
        country: 'Country',
        state: 'State',
        city: 'City',
        email: 'Email',
        cellPhone: 'Mobile phone',
        race: 'Race/Color',
        disability: 'Disability',
        disabilityDesc: 'Disability description',
      },
    },
    step3: {
      title: 'Pre-Check-in Completed!',
      body: 'Guests have been linked to reservation #{id}. When you arrive at the hotel, check-in will be faster since your information is already registered.',
      registeredGuests: 'Registered guests:',
      mainGuestLabel: 'Main Guest',
    },
    guestLabel: {
      main: 'Main',
      child: 'Child {n}',
      adult: 'Adult {n}',
    },
    genericSubmitError: 'Error submitting pre-check-in.',
    options: {
      gender: { M: 'Male', F: 'Female' },
      marital: {
        0: 'Single', 1: 'Married', 2: 'Divorced', 3: 'Widowed', 4: 'Domestic Partnership',
      },
      mainDocTypes: { 0: 'CPF', 1: 'Passport', 2: 'RNE (Foreign ID)' },
      typeDoc: {
        0: 'CPF', 1: 'RG (Brazilian ID)', 2: 'CNH (Driver License)', 3: 'Passport', 4: 'RNE (Foreign ID)', 5: 'Birth Certificate', 6: 'Other',
      },
      race: {
        0: 'White', 1: 'Black', 2: 'Mixed (Pardo)', 3: 'Asian', 4: 'Indigenous', 5: 'Not Declared',
      },
      disability: {
        0: 'None', 1: 'Physical', 2: 'Visual', 3: 'Hearing', 4: 'Intellectual', 5: 'Multiple',
      },
    },
  },
}
